import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';
import './styles.scss';
import { searchClient, CMS_INDEX_NAME, OCS_INDEX_NAME } from '../config';
import { algoliaInsightsPlugin } from '../plugins';
import config from '../../../../lib/frontend-config';

// ensure the container is available
const searchInput = document.querySelector('#autocomplete') as HTMLInputElement;
if (searchInput) {
  // init algolia autocomplete
  autocomplete({
    container: searchInput,
    placeholder: ss.i18n._t('SEARCH.ENTER_TERM'),
    insights: true,
    plugins: [algoliaInsightsPlugin],
    // show the results-panel when the autocomplete-input gets focus
    openOnFocus: false,
    detachedMediaQuery: 'none',
    onSubmit(params: OnSubmitParams<TItem>) {
      // get the search results page link from the global config
      const resultsPageLinkRaw = config.get('SEARCH_RESULTS_PAGE_LINK');

      if (!resultsPageLinkRaw) {
        throw new Error(
          '/search/autocomplete/index.ts -> No search results page link found in global config!',
        );
      }

      // ensure we don't have a query string in the url
      const resultsPageLink =
        resultsPageLinkRaw.indexOf('?') > -1
          ? resultsPageLinkRaw.split('?')[0]
          : resultsPageLinkRaw;
      window.location.href = `${resultsPageLink}?query=${params.state.query}`;
    },
    getSources({ query }) {
      return [
        {
          sourceId: 'pages',
          getItems() {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: CMS_INDEX_NAME,
                  params: {
                    query,
                    hitsPerPage: 5,
                    attributesToSnippet: ['title:1', 'description:35'],
                    snippetEllipsisText: '…',
                  },
                },
                /*{
                  indexName: OCS_INDEX_NAME,
                  params: {
                    query,
                    hitsPerPage: 5,
                    attributesToSnippet: ['title:1', 'description:35'],
                    snippetEllipsisText: '…',
                  },
                }*/
              ],
            });
          },
          templates: {
            item({ item, components, html }) {
              return html`
                <a href="${item.objectLink}">
                  <div
                    class="autocomplete-result"
                    data-target="${item.objectLink}"
                  >
                    <div class="autocomplete-result__icon">
                      <i class="icon-arrow-right"></i>
                    </div>

                    <div class="autocomplete-result__content">
                      ${item.objectTitle}
                    </div>
                  </div>
                </a>
              `;
            },
            noResults() {
              return ss.i18n._t('SEARCH.NO_RESULTS');
            },
          },
          getItemUrl({ item }) {
            return item.objectLink;
          },
        },
      ];
    },
    // overwrite the render method to render a button
    // at the end of the hit's list
    render({ elements, render, html }, root) {
      //
      const { pages } = elements;

      const resultsPageLinkRaw = config.get('SEARCH_RESULTS_PAGE_LINK');
      if (!resultsPageLinkRaw) {
        throw new Error(
          '/search/autocomplete/index.ts -> No search results page link found in global config!',
        );
      }
      // ensure we don't have a query string in the url
      const resultsPageLink =
        resultsPageLinkRaw.indexOf('?') > -1
          ? resultsPageLinkRaw.split('?')[0]
          : resultsPageLinkRaw;
      // get the autocomplete input field to get the search-term from
      const autocompleteInput = document.querySelector(
        'header .aa-Input',
      ) as HTMLInputElement;
      const searchTerm = autocompleteInput.value;

      // Ensure the panel is positioned below the input field
      // Get the position of the input field
      const rect = autocompleteInput.getBoundingClientRect();
      // Calculate the top position for the panel (below the input field) and add some spacing
      const top = rect.y + rect.height + 2;
      // Set the top position of the panel
      const panel = document.querySelector('.aa-Panel') as HTMLDivElement;
      panel.style.top = `${top}px`;

      render(
        html`<div class="aa-PanelLayout aa-Panel--scrollable">
          <div>${pages}</div>
          <a
            href="${resultsPageLink}?query=${searchTerm}"
            class="button button--highlight"
          >
            ${ss.i18n._t('SEARCH.SEE_ALL_RESULTS')}
          </a>
        </div>`,
        root,
      );
    },
  });
}
